import ru from "vuetify/src/locale/ru";

export default {
  $vuetify: ru,
  ru: "RU",
  kk: "KZ",
  hello: "Privet",
  attention: "Внимание",
  cancel: "Отмена",
  update: "Обновить",
  close: "Закрыть",
  "no-data": "Нет данных",
  back: "Назад",
  summary: "Итого",
  expand: "Развернуть",
  questionnaire: {
    notice:
      "Уважаемый потребитель! С целью улучшения качества оказываемых услуг просим ответить на вопросы <u> нашей Анкеты!</u>",
    title: "Анкета оценки удовлетворенности потребителей - юридических лиц",
    title1: "Уважаемый потребитель!",
    title2:
      "В целях улучшения качества обслуживания проводится анкетирование потребителей юридических лиц на предмет предоставления возможности оплаты за оказываемые ТОО «АлматыЭнергоСбыт» услуги – безналичным путем.",
    title21:
      "Филиал АО «Алатау Жарық Компаниясы» - «Энергосбыт» стремится узнать Ваше мнение о своей деятельности с целью улучшения качества оказываемых услуг и реализуемой продукции. Просим Вас ответить на вопросы, и специалисты Филиала АО «Алатау Жарық Компаниясы» - «Энергосбыт» обязательно учтут Ваше мнение в своей дальнейшей работе!",
    title3: "Просим Вас принять участие!",
    title4: "Наименование Вашего предприятия:",
    title5: "Мы благодарим  Вас за оказанное содействие!",
    "question-number": "Вопрос №{num} из {count}",
    send: "Отправить анкету",
    next: "Далее",
    fill: "Укажите перечень товаров/услуг",
    select:
      "Оцените по 5-балльной шкале степень Вашей удовлетворенности работой Филиала АО «Алатау Жарық Компаниясы» - «Энергосбыт»  1 – плохо, 2 - неудовлетворительно, 3 - удовлетворительно, 4 - хорошо, 5 – отлично",
  },
  ui: {
    print: "Распечатать",
    labels: {
      yes: "Да",
      no: "Нет",
      close: "Закрыть",
    },
    wait: "Пожалуйста, подождите...",
    document_loading:
      "Ваш документ загружается и будет открыт в этом окне. Пожалуйста, подождите...",
    list_all: "Все",
    no_data_for_period: "Нет данных за выбранный период",
    "date-picker": {
      label: "Выберите период",
      from: "с",
      to: "по",
    },
    errors: {
      timeout:
        "Превышено количество пользователей.<br/>Пожалуйста, попробуйте позже",
    },
  },
  messageAyth:
    'Уважаемый пользователь! Теперь у Вас возможность совершить вход в Личный кабинет по подтвержденному электронному адресу. Для этого установите пароль в Профиле Личного кабинета. С уважением, ТОО "АлматыЭнергоСбыт".',
  "update-checker": {
    message:
      'Доступна новая версия Личного кабинета.<br /><br /> Обновить? <br /><br />Нажмите "Обновить", чтобы перезагрузить страницу. Все введённые данные при этом будут утеряны.',
  },
  maintenance: {
    message:
      '<center><b>Внимание!</b> <span style="font-weight: 400"> <br /><br /> Ведутся технические работы. <br /><br /> Приносим извинения <br /> за доставленные неудобства.</span> </center>',
    banner: {
      title: "Ведутся технические работы",
      description:
        "Возможна временная недоступность сервисов. Спасибо за понимание.",
    },
  },
  "app-header": {
    feedback: "Обратная связь",
    "contact-center": "Круглосуточный контакт-центр 356-99-99",
    departments: "Районные отделения АлматыЭнергоСбыт (РОЭС)",
  },
  "app-navigation": {
    contract: "Договор",
    "contract-placeholder": "Выберите номер",
    bin: "БИН",
    organization: "Организация",
    "home-tooltip": "Список договоров",
    "profile-tooltip": "Профиль",
    "exit-tooltip": "Выход",
    "pay-tooltip": "Оплатить",
    "appeal-tooltip":
      "Мои обращения. Форма обратной связи для отправки предложений и обращений и получения ответов от Филиала АО «Алатау Жарық Компаниясы» - «Энергосбыт»",
    contracts:
      "Общая информация о договоре: дата заключения, день предоставления показаний",
    abonent:
      "Здесь указаны ваши реквизиты: свидетельство о постановке на учет по НДС, информация о сотрудниках",
    points:
      "Информация об установленных приборах учета, пломбах  и трансформаторов тока, тарифы, ТП",
    calcs:
      "Просмотр информации по начислениям и оплатам в разрезе услуг и периодов",
    actions:
      "Передача показаний, получение и отправка Акта сверки и Акта выполненных работ",
    notices: "Просмотр уведомлений о задолженности",
    reports:
      "Просмотр документов: акты сверки взаиморасчетов, акты выполненных работ, счета на оплату, приложение 2",
    invoices: "Просмотр счетов-фактур",
  },
  "app-menu": {
    "debt-button": "Задолженность по договору",
    contract: "Договор",
    abonent: "Потребитель",
    "accounting-points": "Точки учета",
    payments: "Начисление и оплата",
    "report-forms": "Отчетные формы",
    actions: "Действия по договору",
    "debt-notifications": "Уведомления <br /> о задолженности",
    invoices: "Счета-фактуры",
  },
  "app-footer": {
    text: "Филиал АО АЖК-Энергосбыт. Разработано АО «АЛСЕКО»",
  },
  "auth-view": {
    title: "Личный кабинет для юридических лиц",
    setted: "На Вашу почту отправлена ссылка на установку пароля.",
    forgot: "Забыли пароль?",
    restore: "Восстановление пароля от Личного кабинета",
    back: "<< Назад ко Входу",
    message1:
      "После подтверждения запроса на восстановление пароля вы получите письмо с инструкциями по восстановлению пароля.",
    message2:
      "Восстановление пароля возможно только при условии подтверждения электронного адреса в Личном кабинете. ",
    message3:
      "Пользователя не существует или некорректный БИН, проверьте данные",
    confirm: "Подтвердить",
    "send-restore-mail":
      "На ваш электронный адрес направлена инструкция по восстановлению пароля. Проверьте вашу почту.",
    notice:
      "Вход в Личный кабинет по электронному адресу возможен только при условии подтверждения электронного адреса в Личном кабинете. ",
    updated: "Ваш пароль успешно сменён. Вы можете выполнить ",
    updated2: " с новым паролем.",
    "new-passw": "Новый пароль",
    "retry-pass": "Подтверждение пароля",
    enter: "Вход",
    form: {
      title: "Вход без ЭЦП",
      "enter-bin": "Введите БИН",
      "enter-iin": "Введите ИИН",
      "credentials-title": "Выберите полномочия",
    },
    "form-eds": {
      title: "Войти с ЭЦП",
    },
    "form-email": {
      title: "Войти с email",
    },
    manuals: {
      "video-inctruction": {
        title: "Посмотреть видеоинструкцию работы личного кабинета",
        href: "https://esalmaty.kz/ru/i3398",
      },
      "get-eds": {
        title: "Получение ЭЦП для юридических лиц",
        href: "https://egov.kz/cms/ru/services/pass_onlineecp",
      },
      "pay-instruction": {
        title: "Инструкция по онлайн оплате",
      },
      instruction: {
        title: "Инструкция",
      },
      "sign-act-instruction": {
        title: "Инструкция по подписанию и отклонению актов",
      },
    },
  },
  credentials: {
    individual: "Физическое Лицо",
    legal: "Юридическое лицо",
    "first-leader":
      "Первый руководитель юридического лица, имеющий право подписи",
    signer: "Лицо, наделенное правом подписи",
    "financial-signer": "Лицо, наделенное правом подписи финансовых документов",
    hr:
      "Сотрудник отдела кадров, наделенный правом подтверждать заявки на выпуск регистрационных свидетельств поданные от сотрудников юридического лица",
    employee: "Сотрудник организации",
  },
  "form-validator": {
    decimal3: "Числовое поле, 10 знаков с точностью до тысячных",
    required: "Поле обязательное для заполнения",
    "string-max": "Максимальная длина строки {max} символов",
    "string-min": "Минимальная длина строки {min} символов",
    bin: "Неверный формат БИН",
    biniin: "Неверный формат БИН/ИИН",
    iin: "Неверный формат ИИН",
    email: "Введён некорректный email",
    pass:
      "Введенный пароль не соответствует требованиям безопасности. Новый пароль должен содержать: Минимум 8, максимум 12 символов; 1 цифру; 1 букву латинского алфавита в верхнем регистре; 1 букву латинского алфавита в нижнем регистре; 1 специальный символ (@#$%&); Для ввода использовать только буквы латинского алфавита;",
    password: "Пароль",
    passwordRepeated: "Повторите пароль",
    pass_create: "Введите новый пароль для входа в кабинет пользователя",
    pass_rep_incorr: "Введенные значения паролей не совпадают",
    link_expired:
      "Срок действия данной ссылки истек. Нажмите «Восстановить пароль» для получения новой ссылки.",
    link_expired2: "Ссылка устарела или была использована ранее",
    pass_updated:
      "Пароль успешно обновлен. Вы будете перенаправлены на страницу входа",
    enter_pass: "Введите пароль",
  },
  storages: {
    computer: "Ваш Компьютер",
    "kaz-token": "Казтокен",
    "id-card": "Личное удостоверение",
    "e-token": "EToken Java 72k",
    "ak-ja-carta": "AK JaCarta",
  },
  eds: {
    sign: "Подписать",
    reject: "Отклонить",
    "sign-with-eds": "Подписать с ЭЦП",
    error:
      "Для работы с ключами электронной цифровой подписи установите или запустите программу NCALayer",
  },
  profile: {
    title: "Профиль",
    organization: {
      title: "Данные об организации",
      "bin-iin": "БИН/ИИН",
      name: "Наименование",
      set_password: "Установить пароль",
      update_password: "Сменить пароль",
      email: {
        title: "Email",
        placeholder: "Введите email",
        edit: "Редактировать  email",
        save: "Сохранить email",
        cancel: "Отменить изменение email",
        "not-verified": "Ваш email не подтвержден",
        "card-no-email":
          "Электронный адрес не введен. Для использования всех возможностей Личного кабинета введите и подтвердите Ваш электронный адрес",
        "card-title": "Подтверждение email",
        "card-not-verified":
          "Ваш электронный адрес{email} не подтвержден.<br />Для использования всех возможностей Личного кабинета необходимо подтвердить электронный адрес",
        "card-link": "Переотправить ссылку для подтверждения",
        "card-text-send":
          "На Ваш электронный адрес {email} было отправлено письмо с ссылкой для подтверждения email.",
        "card-text-confirm": "Ваш электронный адрес успешно подтвержден",
      },
    },
    users_management: {
      title: "Управление пользователями",
      first_name: "Имя",
      last_name: "Фамилия",
      patronymic: "Отчество",
      iin: "ИИН",
      roles: "Роли",
      email: "Email",
      contracts: "Договоры",
      status: {
        label: "Статус",
        active: "Активен",
        blocked: "Заблокирован",
      },
      status_filter: {
        all: "Все",
        active: "Активные",
        blocked: "Заблокированные",
      },
      email_not_verified: "Email не подтвержден",
      email_verification:
        "Электронный адрес {email} не подтвержден. Для получения уведомлений необходимо подтвердить электронный адрес",
      email_verification_sent:
        "На электронный адрес {email} было отправлено письмо с ссылкой для подтверждения email",
      email_unavailable:
        "Электронный адрес существует в базе. Попробуйте другой",
      contracts_header: "Ответственный за договоры",
      add_user: "Добавить нового пользователя",
      edit_user: "Редактировать пользователя",
      placeholder: {
        first_name: "Введите фамилию",
        last_name: "Введите имя",
        patronymic: "Введите отчество",
        iin: "Введите ИИН",
        email: "Введите email",
        role: "Выберите роль",
        contract: "Выберите договор",
      },
      button: {
        add_user: "Добавить пользователя",
        edit: "Редактировать",
        add: "Добавить",
        cancel: "Отменить",
        save: "Сохранить",
      },
      errors: {
        user_add: "Ошибка при создании нового пользователя",
        user_edit: "Ошибка при сохранении данных пользователя",
      },
      confirmation: {
        block:
          "Вы подтверждаете блокировку пользователя {user} ({email})?<br><b>Работа пользователя в программе будет завершена</b>",
        unblock: "Вы подтверждаете разблокировку пользователя {user} ?",
      },
    },
  },
  contracts: {
    number: "Договор",
    date: "Дата заключения",
    region: "Регион",
    list: "Список договоров",
    empty: "Нет действующих договоров",
  },
  contractInfo: {
    contract_number: "Договор",
    contract_open_date: "Дата заключения",
    roes: "РОЭС",
    contract_phone: "Телефоны",
    suppl_org_branch_address: "Адрес",
    date_contract_pay_day: "Дата оплаты по договору",
    date_check: "День предоставления показаний",
    ingener_calc: "Инженер-расчетчик",
    info: "Информация",
    saldo: "Текущее сальдо, тг",
    saldo_peni: "Сальдо пени, тг",
    saldo_duty: "Сальдо гос. пошлины, тг",
    assigned_power: "Уст. мощность, кВт",
    rate_nds: "НДС, %",
    contract_consumption_category: "Категория потребителя",
    contract_consumption_category_group: "Группа потребителя",
    week_ends: "Количество выходных в неделе",
    work_hours: "Количество рабочих часов в сутках",
    "1e":
      "Приложение 1Э. Объем отпуска электрической энергии и мощности на {year} год, кВт∙ч",
    status: {
      added:
        "Внимание! На Ваших объектах электроснабжения по договору {contract_id} поставка электроэнергии будет прекращена.",
      in_process:
        "Внимание! На Ваших объектах электроснабжения по договору {contract_id} поставка электроэнергии будет прекращена {date}.",
      terminated:
        "Внимание! На Ваших объектах электроснабжения по договору {contract_id} поставка электроэнергии прекращена {date}.",
      info:
        "<br /><br />За повторное подключение объектов электроснабжения, отключенных за просроченную дебиторскую задолженность, в обязательном порядке взимается плата за повторное подключение в размере {sumPPE} тенге.",
    },
  },
  abonentInfo: {
    consumer: "Потребитель",
    req: "Реквизиты",
    contract_bin: "БИН/ИИН",
    contract_bank_name: "Наименование банка",
    contract_bank_number: "Расчетный/корреспондентский счёт",
    is_resident: "Резидент",
    yes: "да",
    no: "нет",
    contract_kbe: "Сектор экономики",
    contract_knp: "Код назначения платежа",
    contractor_country_name: "Код страны резидента",
    district_name: "Административный район",
    contractor_real_address: "Адрес местонахождения",
    receiver_name: "Грузополучатель",
    contract_address: "Юридический адрес",
    contract_post_index: "Почтовый индекс",
    nds: "Свидетельство о постановке на учет по НДС",
    contract_nds_date: "Дата",
    contractor_tax_branch_name: "Налоговый орган",
    nds_series: "Серия",
    nds_number: "Номер",
    employes: "Сотрудники и контактная информация",
    phone: "Телефон",
    fax: "Факс",
    email: "Email",
  },
  accountingPoints: {
    more_details: "Подробнее",
    points: "Точки учета",
    account_point_number: "Номер",
    account_point_name: "Наименование",
    status: "Статус",
    meter_next_verify_date: "Дата поверки прибора учета",
    tarif_value: "Тариф, тг. (без НДС)",
    net_node_name: "Номер ТП (РП, секции)",
    account_point_full_address_name: "Адрес",
    connected: "Подключен",
    disconnected: "Отключен",
    all: "Все",
    connecting: "Подключенные",
    disconnecting: "Отключенные",
  },
  pointMeter: {
    meter: "Прибор учета",
    meter_number: "Номер",
    meter_type_name: "Тип",
    prec_phase_number: "Значность/Фазность",
    meter_install_date: "Дата установки",
    meter_next_verify_date: "Дата поверки",
    sum_consumption: "Последний расход",
  },
  pointSeal: {
    seals: "Пломбы",
    meter_seal_number: "Номер",
    seal_place_name: "Место установки",
    date_meter_seal_set: "Дата установки",
  },
  pointTrans: {
    trans: "Трансформаторы тока",
    transformer_number: "Заводской номер",
    transformer_name: "Тип",
    koef: "Коэффициент",
    meter_seal_number: "Номер пломбы",
  },
  reportsInfo: {
    title: "Отчетные формы",
    "application-2": {
      title: "Приложение №2 к договору электроснабжения на текущий год",
    },
    "application-1": {
      title: "Приложение №1 к договору электроснабжения на текущий год",
    },
    "form-470": {
      title: "Ф-470 Приложение расчета потерь",
    },
    download: "Сохранить",
    show: "Показать",
    "consumption-report": {
      title: "Сведения о расходе электроэнергии",
    },
    "invoice-act": {
      title: "Акт выполненных работ",
    },
    "invoice-bill": {
      title: "Счёт на оплату",
    },
    "reconciliation-report": {
      title: "Акт сверки взаиморасчетов",
    },
    "reconciliation-report-netto": {
      title: "Акт сверки нетто-потребитель",
    },
    "contract-vie": {
      title: "Договор ВИЭ",
    },
    "exp-invoice": {
      title: "Расходная накладная",
    },
    initial_period_later_than_final: "Начальный период позже конечного",
    "no-data": "Нет данных за выбранный период",
    "runtime-error": "Произошла ошибка во время формирования отчета",
    power_consumption: "Уведомление по режиму электропотребления",
  },
  paymentsInfo: {
    title: "Начисление и оплата",
    serv_electricity: `Электроэнергия, тг (с НДС)`,
    serv_fine: "Пеня, тг",
    serv_duty: "Госпошлина, тг",
    serv_reconnect: "ППЭ, тг (с НДС)",
    calcs: "Оплата, тг",
    headers: {
      period: "Период",
      sum_in: "Сальдо входящее, тг",
      sum_calc: "Начислено, тг",
      sum_pay: "Оплачено, тг",
      sum_out: "Сальдо исходящее, тг",
    },
    "headers-electricity": {
      count_calc: "кВт∙ч",
      sum_calc_no_nds: "Начислено, тг (без НДС)",
      sum_nds: "НДС, тг",
      avg_tariff: "Сред.тариф, тг/(кВт∙ч) (без НДС)",
    },
    "headers-reconnect": {
      sum_calc: "Начислено, тг (с НДС)",
    },
    "headers-calc": {
      date_pay: "Дата оплаты",
      sum_pay: "Сумма оплаты, тг",
    },
  },
  "action-send-count": {
    actions: "Действия по договору",
    send_count: "Передача показаний",
    info_on_date: "Ф-401 Сведения о расходе электроэнергии на {data}",
    contract_number: "Договор {contract} от {data}, {roes}",
    date_today: "Дата предоставления показаний",
    date_counts: "Выберите дату новых показаний",
    account_point_number: "Точка учета",
    meter_number: "Прибор учета",
    indications_end: "Предыдущие показания (суммарные)",
    consumption_value_calc: "Предыдущий расход электроэнергии",
    indications_new: "Новые показания",
    indications: "Показания (фото)",
    send_counts: "Отправить показания",
    select_file: "Выбрать файл",
    check_data: "Выберите дату новых показаний",
    point_name: "Наименование точки учета",
    point_adres: "Адрес точки учета",
    prec: "Значность",
    koef: "Коэффициент",
    calc_type: "Признак расчета",
    less_than_previous: "Показания меньше предыдущих",
    greater_than_subsequent: "Показания больше последующих",
    try_again: "Показания не приняты, попробуйте снова.",
    not_access:
      "Нет доступа на внесение изменений. По договору сохранен счет-фактура!",
    sended:
      //  "15.07.2025 ж. тарифтің өзгеруіне байланысты, көрсеткіштер берілгеннен кейін, шот 2 жұмыс күні ішінде сақталады. / В связи с изменениями тарифа 15.07.2025, счет будет сохранен в течении 2 рабочих дней после передачи показаний",
      "Показания приняты и переданы в Филиал АО «АЖК» - «Энергосбыт». Информация о готовности счета на оплату поступит дополнительно",
    input_value: "Введите значение",
    confirm_next_page:
      "При переходе на следующий лист введенные Вами показания будут утеряны. Выполнить переход на следующий лист?",
    file_size_error: "Объем прикрепляемого файла не должен превышать 28 Mb",
    file_ext_error: "Допустимыe форматы файлов: png, jpg, jpeg, gif, pdf",
    already_taken:
      "Показания на {date} ранее уже были приняты в Филиал АО «АЖК» - «Энергосбыт»",
    consumption_more_50_percent:
      "Среднемесячное потребление больше предыдущего на 50%. Показания будут переданы, проверьте корректность введенных показаний!",
    consumption_less_50_percent:
      "Среднемесячное потребление меньше предыдущего на 50%. Показания будут переданы, проверьте корректность введенных показаний!",
    calc: "Расход",
    seal_deleted: "Прибор учета распломбирован, отправка показаний невозможна",
    point_disconnected: "Прибор учета отключен, отправка показаний невозможна",
    yes: "да",
    no: "нет",
    allPointsIndicationsAreRequired:
      "Для расчета необходимо указать показания по всем точкам учета",
    indicationNotSend:
      "Внимание! Передача показаний возможна с 20.01.2025 года.",
    message1:
      "Показания присоединены в базу Филиала АО «АЖК» - «Энергосбыт». Счет на оплату будет отправлен позднее. Уведомление о готовности счета будет направлено вам на электронную почту.",
    message2:
      "Показания присоединены в базу Филиала АО «АЖК» - «Энергосбыт». Для повторной отправки показаний необходимо обратиться в {roes} по адресу {adres}.",
    firstDay: "Ввод показаний на 1 число месяца запрещен",
  },
  actions: {
    title: "Действия по договору",
    send: "Передача показаний",
    is_mobile:
      "Уважаемый потребитель!\n" +
      "Для получения услуг в полном объеме просим воспользоваться персональным компьютером, на котором установлена программа NCLayer.\n" +
      "Данный способ является временным на период проведения доработок.\n" +
      "Мы сообщим дополнительно об окончании работ в наших социальных сетях.",
    "change-plan": {
      once: "Заявку можно отправлять только один раз в месяц",
      "select-status": "Выберите статус",
      title: "План реализации",
      create: "Создать заявку",
      action: "Изменить план",
      number: "Номер",
      date_create: "Дата создания",
      date_send: "Дата отправки ",
      contract: "Номер договора",
      status: "Статус",
      month: "Месяц",
      kvt: "кВт.час (текущие)",
      kvtnew: "кВт.час (новые)",
      request:
        "Заявление об изменении поставки электроэнергии по договору № {contract_number}",
      fill:
        "Заполните данные о поставке электроэнергии за период {period_begin} - {period_end}",
      cancel: "Отменить",
      save_draft: "Сохранить черновик",
      send: "Отправить",
    },
    akt: {
      title: "Акт сверки взаиморасчетов",
      "group-header":
        'Акт за период с <span style="color:black;">{period_begin}</span> по <span style="color:black;">{period_end}</span>, выдан <span style="color:black;">{action_date}</span>',
      "act-sum": "Сумма по акту",
      "reject-reason": "Отклонен по причине",
      "select-reject-reason": "Выберите причину",
      "need-reject-reason":
        "Укажите причину отклонения для дальнейшего выполнения действия",
    },
    akt_work: {
      title: "Акт выполненных работ",
      "group-header":
        'Акт <span style="color:black;">{act_number}</span> за <span style="color:black;">{period}</span> от <span style="color:black;">{action_date}</span>',
    },
    akt_netto: {
      title: "Акт сверки нетто-потребитель",
      "group-header":
        'Акт за период с <span style="color:black;">{period_begin}</span> по <span style="color:black;">{period_end}</span>, выдан <span style="color:black;">{action_date}</span>',
      "act-sum": "Сумма по акту",
      "reject-reason": "Отклонен по причине",
      "select-reject-reason": "Укажите причину",
      "need-reject-reason":
        "Укажите причину отклонения для дальнейшего выполнения действия",
    },
    contract_vie: {
      title: "Договор ВИЭ",
      "group-header":
        'Договор <span style="color:black;">{contract_number}</span>, от <span style="color:black;">{contract_date}</span>',
      "reject-reason": "Отклонен по причине",
      "select-reject-reason": "Укажите причину",
      "need-reject-reason":
        "Укажите причину отклонения для дальнейшего выполнения действия",
    },
    exp_invoice: {
      title: "Расходная накладная",
      "group-header":
        'Накладная за период с <span style="color:black;">{period_begin}</span> по <span style="color:black;">{period_end}</span>, выдана <span style="color:black;">{action_date}</span>',
      "act-sum": "Сумма по накладной",
      "reject-reason": "Отклонен по причине",
      "select-reject-reason": "Укажите причину",
      "need-reject-reason":
        "Укажите причину отклонения для дальнейшего выполнения действия",
    },
    accept: {
      title: "Заявление об акцепте договора электроснабжения",
      "required-fields":
        "Для подачи заявления необходимо заполнить следующие поля",
      "invalid-phone": "Некорректный номер телефона",
      "phone-number": "Сотовый номер",
      "phone-number-media": "Сотовый номер для мультимедийного сообщения",
      "phone-number-messenger": "Сотовый номер для мессенджеров",
      "mail-address": "Почтовый адрес",
      "before-route-leave":
        'Уважаемый пользователь, любые действия по договору не могут быть выполнены без подписания формы "Заявление об акцепте договора электроснабжения", вы точно хотите закрыть?',
      email: {
        "card-no-email":
          "Ваш электронный адрес не введен.<br />Для подписания акцепта необходимо перейти в профиль,<br />ввести и подтвердить электронный адрес",
        "card-not-verified":
          "Ваш электронный адрес{email} не подтвержден.<br />Для подписания акцепта необходимо перейти в профиль и подтвердить электронный адрес.",
        "open-profile-page": "Перейти в профиль",
      },
    },
    statuses: {
      all: "Все",
      pending: "В ожидании",
      signed: "Подписан",
      rejected: "Отклонен",
    },
    "choose-reject-reason":
      "Укажите причину отклонения для дальнейшего выполнения действия",
  },
  debtNotifications: {
    title: "Уведомления о задолженности",
    title_single: "Уведомление о задолженности",
    notice_seen: "Ознакомлен",
    saldo: "Текущее сальдо",
    dateFilter: "По дате:",
    filterNew: "сначала новые",
    filterOld: "сначала старые",
    number_date: "Номер и дата уведомления",
    debt_sum: "Сумма долга, тг",
    date_formed: "Дата формирования уведомления",
    date_send: "Дата отправки уведомления",
    delivery_type: "Тип доставки",
    months: "Срок задолженности, мес",
    repaid: "Погашено",
    date_last: "Дата последней оплаты",
    pay_last: "Оплачено по уведомлению, тг",
    rowTooltip: "Подробнее",
  },
  appeals: {
    title: "Мои обращения",
    create: "Создать обращение",
    edit: "Редактировать",
    select_status: "Выберите статус",
    number: "Номер",
    date_create: "Дата создания",
    date_send: "Дата отправки",
    theme: "Тема",
    contract_number: "Номер договора",
    status: "Статус",
    contact_human: "Контактное лицо",
    email: "Email",
    phone: "Контактный номер",
    theme_appeal: "Тема обращения",
    contract: "Договор",
    message: "Текст сообщения",
    save_draft: "Сохранить черновик",
    cancel2: "Отменить",
    cancel: "Отменить заявку",
    send: "Отправить",
    fio: "Фамилия Имя Отчество",
    select_theme: "Выберите тему обращения",
    all: "Все",
    input_text: "Введите текст обращения",
    drag_file:
      "Перенесите файл любого формата не более 50 Мб, чтобы прикрепить его или ",
    browse: "Обзор",
    answer: "Ответ по обращению",
    title2: "Исходящие обращения",
    in: {
      title: "Входящие обращения",
      title2: "Входящее обращение",
      date_send: "Дата поступления",
      drag_file:
        "Перенесите файл любого формата не более 28 Мб, чтобы прикрепить его или ",
      send: "Отправить в РОЭС",
      close: "Закрыть",
      close_confirm:
        "Данные не будут сохранены, Вы действительно хотите выйти?",
      date_create: "Дата поступления",
    },
  },
  invoices: {
    docs: "Получить документы Вы можете на портале ИС «ЭСФ»",
    invoice_label: "СФ",
    invoice_date_preposition: "от",
    invoice_additional: "дополнительный",
    invoice_revised: "исправленный",
    to_invoice: "к СФ",
    to_invoice_preposition: "за",
    headers: {
      name: "Наименование товара (работ, услуг)",
      code: "Код товара (ТН ВЭД ЕАЭС)",
      unit: "Единица измерения",
      quantity: "Количество (объем)",
      price: "Цена",
      cost: "Стоимость товаров (работ, услуг)",
      tax_rate: "Ставка НДС",
      tax_sum: "Сумма НДС",
      cost_with_tax: "Всего стоимость реализации",
      total_taxable: "Итого облагаемый оборот",
      total_nontaxable: "Итого необлагаемый оборот",
      total: "Всего по счету",
    },
  },
  rating: {
    mark: "Оцените работу приложения",
    imp: "Ваше мнение важно для нас",
    cancel: "Отмена",
    make_mark: "Оценить",
    thanks: "Спасибо за Вашу оценку!",
    close: "Закрыть",
    stars5: "Отлично",
    stars4: "Хорошо",
    stars3: "Есть что улучшить",
    stars2: "Средне",
    stars1: "Плохо",
    comment: "Добавить комментарий",
    bad_interface: "Неудобный интерфейс",
    few_func: "Недостаточно функций ЛК",
    other: "Другое",
  },
  "pay-form": {
    pay: "Оплатить",
    close: "Закрыть",
    "cur-period": "За текущий период",
    "sum-pay": "Сумма к оплате, тг",
    "payed-summ": "Оплачиваемая сумма, тг",
    "input-summ": "Введите сумму к оплате",
    "invoice-bill": "Счёт на оплату",
    "have-no-bill": "Неоплаченных счетов нет",
    "choose-acquirer": "Выберите способ оплаты",
    "sum-range-error": "Сумма должна быть не менее 60тг и не более 499 999тг",
    "for-period": "За период",
  },
  electricityReport: {
    name: "Ф-402 Ведомость электропотребления",
    show: "Показать",
    label: "Выберите период",
    contractAmount: "Всего за рассчётный период",
    tableHeaders: {
      pointNumber: "Код ТУ",
      pointName: "Наименование ТУ",
      meterNumber: "Номер счетчика/Тарифная зона",
      indicationsBegin: "Показания на начало периода",
      indicationsEnd: "Показания на конец периода",
      indicationsDiff: "Разность показаний",
      transformCoef: "Расч. коэф.",
      consumptionMeter: "Расход по ПУ, кВт.ч",
      consumptionCalc: "Расход без ПУ, кВт.ч",
      consumptionDop: "Доп. расход, кВт.ч",
      consumptionSPM: "СПМ, кВт.ч",
      consumptionLost: "Потери, кВт.ч",
      consumptionSub: "Субабоненты, кВт.ч",
      consumptionRecalc: "Перерасчет, кВт.ч",
      consumptionOperation: "Потребление, кВт.ч",
    },
  },
  "pay-instruct": {
    str1: "Онлайн оплата в Личном кабинете юридических лиц",
    str2:
      "В Личном кабинете предусмотрена возможность совершения оплаты за услугу «Электроэнергия» в режиме онлайн для юридических лиц Филиал АО «Алатау Жарық Компаниясы» - «Энергосбыт». Один потребитель может производить оплату любое количество раз.",
    str3: "Функция оплаты доступна в верхней панели Личного кабинета:",
    str4:
      "Если на текущий момент нет сформированного счета, то при нажатии на иконку «Оплатить» выдает сообщение – «Неоплаченных счетов нет»:",
    str5:
      "При нажатии на кнопку «Оплатить» открывается окно с возможность выбора способа оплаты – посредством Qiwi и Kaspi:",
    str6:
      "Далее Вам необходимо выбрать способ оплаты, заполнить сумму и нажать на кнопку «Оплатить»:",
    str7:
      "Если Вы выберете способ оплаты Qiwi, то система переведет вас на сервис «Интернет банкинг Qiwi»:",
    str8:
      "Если Вы выберете способ оплаты Kaspi, то система переведет вас на сервис «Интернет банкинг Kaspi»:",
    str9:
      "На стороне банка будет принят платеж и в Системе отобразится сообщение об успешности проведения платежа. Датой платежа считается дата, когда платеж поступил и был зафиксирован в базе данных.",
  },
  "sign-act-instruct": {
    str2:
      "Подписание, отклонение актов сверки взаиморасчетов потребителем и актов выполненных работ доступно в Личном кабинете без обращения в РОЭС. ",
    str3: "1.	Подписание акта",
    str4:
      "Действие «Подписать с ЭЦП» выполняется с подписью ЭЦП и доступно пользователю при условии, если акт не был отклонен (то есть, не в статусе «Отклонен» и нет причины) или не был подписан (то есть, не в статусе «Подписан») ранее пользователем Личного кабинета. ",
    str5:
      "1.	Для подписания акта необходимо открыть форму «Действия по договору» (рисунок 1).",
    str6: "Рисунок 1 – форма «Действия по договору»",
    str7:
      "2.	Далее выбрать «Акт сверки взаиморасчетов» или «Акт выполненных работ» (рисунок 2) за необходимый период из списка сформированных актов.",
    str8: "Рисунок 2 – форма при открытии «Акт сверки взаиморасчетов»",
    str9: "3.	Подписать сформированный акт с помощью ЭЦП (рисунок 3 и 4).",
    str10: "Рисунок 3 –  «Акт сверки взаиморасчетов» со статусом «В ожидании» ",
    str1: "Рисунок 4 – Окно для выбора ЭЦП ",
    str11:
      "4.	После успешного подписания акта со стороны Филиала АО «Алатау Жарық Компаниясы» - «Энергосбыт» поступит уведомление о подписании акта на подтвержденный электронный адрес, указанный в Профиле в ЛК. ",
    str12:
      "5.	Статус акта на форме «Действия по договору» изменится на «Подписан» (рисунок 5).",
    str13: "Рисунок 5 – Статус «Подписан» акта сверки взаиморасчетов ",
    str14:
      "6.	Подписанный акт с QR кодами подписей отображается на форме «Действия по договору». ",
    str15: "2.	Отклонение актов",
    str16:
      "Если требуется отклонить акт, то данное действие выполняется без подписи ЭЦП и доступно на форме «Действия по договору». ",
    str17:
      "1.	Открыть «Акт сверки взаиморасчетов» или «Акт выполненных работ» и выбрать тот, который требуется отклонить. Нажать на действие «Отклонить» (рисунок 6).",
    str18: "Рисунок 6 – Расположение действия «Отклонить»",
    str19:
      "2.	После нажатия на действие «Отклонить» откроется окно, в котором можно выбрать причину отклонения из выпадающего списка (рисунок 7 и 8). ",
    str20: "Рисунок 7 – Окно выбора причины отклонения",
    str21: "Рисунок 8 - Список причин отклонения",
    str22:
      "3.	После указания причины статус акта будет изменён на «Отклонён» (рисунок 9).",
    str23: "Рисунок 9 – Статус акта после отклонения",
  },
  budget_cons_not: {
    str1: "УВЕДОМЛЕНИЕ",
    str2: "Уважаемый потребитель!",
    str3:
      "Согласно пп. 2 п. 2 ст. 19 Закон РК от 09.07.2004 года № 588-II «Об электроэнергетике», потребители электрической и тепловой энергии обязаны соблюдать режимы энергопотребления, определенные договором купли-продажи электрической и тепловой энергии.",
    str4:
      "В соответствии с п. 7 Типового договора электроснабжения для юридических лиц, финансируемых из государственного бюджета утвержденного приказом Министра энергетики РК от 23.10.2017 года № 356 (далее Типовой договор), для определения величины потребления электрической энергии на очередной год Потребитель не позднее, чем за 30 (тридцать) дней до начала года, предшествующего году поставки, подает предварительную заявку о поставке электрической энергии по форме, согласно приложению 2 к Типовому договору. Указанный документ определяет режим электропотребления на соответствующий год поставки.",
    str5:
      "Согласно пп. 2 п. 15 Типового договора, Потребитель обязан соблюдать режимы энергопотребления, определенные договором купли-продажи электрической энергии.",
    str6:
      "В соответствии с п. 16 Типового договора, Продавец, посредством привлечения энергопередающей организации, имеет право прекратить полностью или частично подачу электрической энергии предупредив Потребителя способами, указанными в акцепте договора (электронной почтой, факсом, почтовым отправлением, короткое текстовым сообщением, мультимедийным сообщением, действующими мессенджерами), позволяющим подтвердить факт отправки уведомления Потребителю, не менее чем за 5 (пять) рабочих дня со дня получения уведомления Потребителем в случаях нарушения установленного Договором режима электропотребления.",
    str7:
      "В связи с изложенным Вам необходимо привести Ваш режим энергопотребления в соответствие с поданной Вами предварительной заявкой о поставке электрической энергии на {current_year} год, в противном случае ТОО «АлматыЭнергоСбыт» по итогам текущего расчетного периода, по истечению 5 (пять) рабочих дней с момента его завершения вынуждено будет полностью или частично подачу прекратить Вам электрической энергии.",
    str8:
      "За повторное подключение объектов электроснабжения в обязательном порядке взимается плата за повторное  подключение в размере 17 321.00 тенге.",
  },
  other_cons_not: {
    str1:
      "Согласно пп. 2 п. 2 ст. 19 Закон РК от 09.07.2004 года № 588-II «Об электроэнергетике», потребители электрической и тепловой энергии обязаны соблюдать режимы энергопотребления, определенные договором купли-продажи электрической и тепловой энергии.",
    str2:
      "В соответствии с п. 8 Типового договора электроснабжения для потребителей, использующих электрическую энергию не для бытовых нужд утвержденного приказом Министра энергетики РК от 23.10.2017 года № 356 (далее Типовой договор), для определения величины потребления электрической энергии на очередной год Потребитель не позднее, чем за 30 (тридцать) дней до начала года, предшествующего году поставки, подает предварительную заявку о поставке электрической энергии по форме, согласно приложению 2 к Типовому договору. Указанный документ определяет режим электропотребления на соответствующий год поставки.",
    str3:
      "Согласно пп. 2 п. 12 Типового договора, Потребитель обязан соблюдать режимы энергопотребления, определенные договором купли-продажи электрической энергии.",
    str4:
      "В соответствии с п. 13 Типового договора, Продавец, посредством привлечения энергопередающей организации, имеет право прекратить полностью или частично подачу электрической энергии предупредив Потребителя способами, указанными в акцепте договора (электронной почтой, факсом, почтовым отправлением, короткое текстовым сообщением, мультимедийным сообщением, действующими мессенджерами), позволяющим подтвердить факт отправки уведомления Потребителю, не менее чем за 5 (пять) рабочих дня со дня получения уведомления Потребителем в случаях нарушения установленного Договором режима электропотребления. ",
    str5:
      "В связи с изложенным Вам необходимо привести Ваш режим энергопотребления в соответствие с поданной Вами предварительной заявкой о поставке электрической энергии на {current_year} год, в противном случае ТОО «АлматыЭнергоСбыт» по итогам текущего расчетного периода, по истечению 5 (пять) рабочих дней со момента его завершения вынуждено будет полностью или частично прекратить подачу Вам электрической энергии.",
    str6:
      "В порядке и сроки определенные п. 9 Типового договора, Вы можете скорректировать определенный договором режим электропотребления на последующие расчетные периоды, подав  до 26 (двадцать шестого) числа текущего месяца в ТОО «АлматыЭнергоСбыт» предварительную заявку о поставке электрической энергии по форме, согласно приложению 2 к Типовому договору. ",
    str7:
      "За повторное подключение объектов электроснабжения в обязательном порядке взимается плата за повторное  подключение в размере 17 321.00 тенге.",
  },
};
